export enum EAccessType {
    VERIFY_RESET_PASSWORD = 'VERIFY_RESET_PASSWORD',
    CONFIRM_RESET_PASSWORD = 'CONFIRM_RESET_PASSWORD',
    SET_NEW_PASSWORD = 'SET_NEW_PASSWORD',
    VERIFY_OTP = 'VERIFY_OTP',
    FAT = 'FAT',
}
